import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CLEAR_CART,
  DECREASE_QUANTITY,
  INCREASE_QUANTITY,
} from "../actions/cart/cart.types";

const initialState = {
  items: [],
  totalQty: 0,
  totalAmount: 0,
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_TO_CART: {
      const item = action.payload;
      const existing = state.items.find(
        (i) => i.productId === item.productId
      );

      let updatedItems;

      if (existing) {
        updatedItems = state.items.map((i) =>
          i.productId === item.productId ? { ...i, quantity: i.quantity + 1 } : i
        );
      } else {
        updatedItems = [...state.items, { ...item, quantity: 1 }];
      }

      return {
        ...state,
        items: updatedItems,
        totalQty: state.totalQty + 1,
        totalAmount: state.totalAmount + item.price,
      };
    }

    case REMOVE_FROM_CART: {
      const productId = action.payload;
      const item = state.items.find((i) => i.productId === productId);

      if (!item) return state;

      return {
        ...state,
        items: state.items.filter((i) => i.productId !== productId),
        totalQty: state.totalQty - item.quantity,
        totalAmount:
          state.totalAmount - item.price * item.quantity,
      };
    }

    case INCREASE_QUANTITY: {
      return {
        ...state,
        items: state.items.map((item) =>
          item.productId === action.payload
            ? { ...item, quantity: item.quantity + 1 }
            : item
        ),
      };
    }

    case DECREASE_QUANTITY: {
      const productId = action.payload;

      const itemToDecrease = state.items.find(
        (item) => item.productId === productId
      );

      if (!itemToDecrease || itemToDecrease.quantity <= 1) {
        return state;
      }

      return {
        ...state,
        items: state.items.map((item) =>
          item.productId === productId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        ),
        totalQty: state.totalQty - 1,
        totalAmount: state.totalAmount - itemToDecrease.price,
      };
    }

    case CLEAR_CART:
      return initialState;

    default:
      return state;
  }
}